import * as React from "react";
import * as cls from "./Container.module.scss";
export { Container };
/**
 * Контейнер — это фундаментальный строительный блок, который ограничивает
 * размер страницы для различных устройств, аналогично контейнеру из Bootstrap
 * (подробнее cм. [Контейнеры][1]).
 *
 * Контейнеры используются для создания шаблонов страниц (фреймов),
 * например, {@link ../product/ProductFrame.jsx}.
 * В конечном приложении лучше использовать фреймы.
 *
 * [1]: https://bootstrap-4.ru/docs/5.3/layout/containers/
 *
 * @summary Контейнер.
 * @param {Object} props - Атрибуты элемента.
 * @param {string} [props.tagName=div] - Имя тега для элемента контейнера.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {JSX.Element} props.children - Содержимое.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * <Container tagName="main" className="product_main">Содержимое</Container>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Container({
  tagName = "div",
  className,
  children,
  isLecture,
  isMobile,
}) {
  let fullClassName = isMobile && isLecture ? "" : cls.container;
  if (className) fullClassName += " " + className;
  return React.createElement(tagName, { className: fullClassName }, children);
}
